<template>
  <div
    class="html_valTypeForPer"
    ref="html_valTypeForPer"
    v-if="
      datas.objectInfo &&
      datas.objectInfo.length == 2 &&
      datas.data.maxDataList[0]
    "
  >
    <div class="main">
      <div class="player_box" v-if="palyerInfor && palyerInfor[0]">
        <template
          v-if="
            palyerInfor[0].playerInfos && palyerInfor[0].playerInfos.length > 0
          "
        >
          <AbPlayerImg
            :playerImg="palyerInfor[0].playerInfos[0].profilePicture"
            :playerNum="palyerInfor[0].playerInfos[0].shirtNumber * 1"
            :playerName="palyerInfor[0].playerInfos[0].playerName"
            :countryImg="palyerInfor[0].teamLogo"
            :countryName="palyerInfor[0].teamName"
            :width="'6.94vw'"
          ></AbPlayerImg>
        </template>
        <template v-else>
          <DelegationImg
            :key="palyerInfor[0].teamId"
            :countryImg="palyerInfor[0].teamLogo"
            :countryName="palyerInfor[0].teamName"
            :width="'5.85vw'"
            :logoHeight="'3.86vw'"
          ></DelegationImg>
        </template>
      </div>

      <div class="mid_box">
        <span class="title_row">
          <!-- <span
            class="titleRow_left"
            v-text="_valFormatHandler(palyerInfor[0].teamScore)"
          ></span> -->
          <span class="titleRow_left">
            <NumberScrolling
              :tarVal="palyerInfor[0].teamScore"
              :unit="''"
            ></NumberScrolling>
          </span>

          <span class="titleRow_center" v-text="''"></span>
          <!-- <span
            class="titleRow_right"
            v-text="_valFormatHandler(palyerInfor[1].teamScore)"
          ></span> -->
          <span class="titleRow_right">
            <NumberScrolling
              :tarVal="palyerInfor[1].teamScore"
              :unit="''"
            ></NumberScrolling>
          </span>
        </span>
        <span
          class="rowItem"
          v-for="item in datas.statisticsModels"
          :key="item.statisticalEn"
        >
          <span class="rowItem_bg"></span>
          <span class="rowItem_valPerArea left">
            <!-- <span
              class="valPerArea_text"
              v-text="
                _valFormatHandler(tableData[0][item.statisticalEn], item.suffix)
              "
            ></span> -->
            <span class="valPerArea_text">
              <NumberScrolling
                :tarVal="tableData[0][item.statisticalEn]"
                :unit="item.suffix"
              ></NumberScrolling>
            </span>

            <span class="valPerArea_bar">
              <span
                class="bar_per"
                :style="{
                  width: `${computedVal2Per(
                    tableData[0][item.statisticalEn],
                    datas.data.maxDataList[0][item.statisticalEn]
                  )}%`,
                }"
              ></span>
            </span>
          </span>
          <span
            class="rowItem_title"
            v-text="_valFormatHandler(item.name)"
          ></span>
          <span class="rowItem_valPerArea right">
            <span class="valPerArea_bar">
              <span
                class="bar_per"
                :style="{
                  width: `${computedVal2Per(
                    tableData[1][item.statisticalEn],
                    datas.data.maxDataList[0][item.statisticalEn]
                  )}%`,
                }"
              ></span>
            </span>
            <!-- <span
              class="valPerArea_text"
              v-text="
                _valFormatHandler(tableData[1][item.statisticalEn], item.suffix)
              "
            ></span> -->
            <span class="valPerArea_text">
              <NumberScrolling
                :tarVal="tableData[1][item.statisticalEn]"
                :unit="item.suffix"
              ></NumberScrolling>
            </span>
          </span>
        </span>
      </div>
      <div class="player_box" v-if="palyerInfor && palyerInfor[1]">
        <template
          v-if="
            palyerInfor[1].playerInfos && palyerInfor[1].playerInfos.length > 0
          "
        >
          <AbPlayerImg
            :playerImg="palyerInfor[1].playerInfos[0].profilePicture"
            :playerNum="palyerInfor[1].playerInfos[0].shirtNumber * 1"
            :playerName="palyerInfor[1].playerInfos[0].playerName"
            :countryImg="palyerInfor[1].teamLogo"
            :countryName="palyerInfor[1].teamName"
            :width="'6.94vw'"
          ></AbPlayerImg>
        </template>
        <template v-else>
          <DelegationImg
            :key="palyerInfor[1].teamId"
            :countryImg="palyerInfor[1].teamLogo"
            :countryName="palyerInfor[1].teamName"
            :width="'5.85vw'"
            :logoHeight="'3.86vw'"
          ></DelegationImg>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
// 运动员数据对比 - val 展示的为百分比 bar Per
// 俩边可以是单个运动员，也可以是国家
import AbPlayerImg from '../components/PlayerImg'
import DelegationImg from '../components/DelegationImg'
import NumberScrolling from '../components/NumberScrolling'
// import htmlDomToImage_base64_data_mixin from '@mixins/htmlDomToImage_base64_data'
export default {
  name: 'html_valTypeForPer',
  // mixins: [htmlDomToImage_base64_data_mixin],
  components: {
    AbPlayerImg,
    DelegationImg,
    NumberScrolling,
  },
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
  },
  data() {
    return {}
  },
  created() {
    // 模拟数据
    console.debug(this.datas)
  },
  updated() {
    console.debug(`更新： ${this.datas}`)
  },
  computed: {
    tableData() {
      return this.datas.data.dataList && this.datas.data.dataList.length > 0
        ? this.datas.data.dataList
        : []
    },
    palyerInfor() {
      return this.datas.objectInfo && this.datas.objectInfo.length > 0
        ? this.datas.objectInfo
        : []
    },
  },
  methods: {
    computedVal2Per(val, total) {
      let valNum = Number(Number(val).toFixed(2))
      let totalNum = Number(Number(total).toFixed(2))
      return (valNum / totalNum).toFixed(4) * 100
    },
    _valFormatHandler(val, ceil) {
      let data
      // console.debug(val, typeof val)
      if (val === undefined || val === null || val === '' || val === ' ') {
        data = ''
      } else {
        if (val && ceil) {
          data = `${val}${ceil ? ceil : ''}`
        } else {
        }
        data = val
      }
      // console.debug(val, data)
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.html_valTypeForPer {
  width: 100%;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: left;
  .main {
    width: 90%;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    color: var(--mixtmt_greyColor_main);

    .player_box {
      width: 6.94vw;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: flex-start;
      font-size: 0.972vw;
    }
    .mid_box {
      width: calc(100% - 2 * 6.94vw);
      padding: 0 0.347vw;
      height: auto;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: flex-start;
      flex-direction: column;
      .title_row {
        width: 100%;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        .titleRow_left,
        .titleRow_right {
          width: 40%;
          text-align: center;
          font-size: 0.972vw;
          line-height: 1.388vw;
          font-weight: bold;
          color: var(--mixtmt_greyColor3);
        }
        .titleRow_center {
          width: 20%;
        }
      }
      .rowItem {
        position: relative;
        width: 100%;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 0.347vw;
        &:last-child {
          margin-bottom: 0;
        }
        .rowItem_bg {
          width: 100%;
          height: 2.083vw;
        }
        .rowItem_title {
          display: block;
          position: absolute;
          left: 50%;
          top: 0;
          transform: translateX(-50%);
          z-index: 2;
          width: 100%;
          height: 100%;
          color: var(--mixtmt_greyColor2);
          font-size: 0.833vw;
          text-align: center;
        }
        .rowItem_valPerArea {
          display: block;
          position: absolute;
          bottom: 0;
          z-index: 2;
          width: 50%;
          display: flex;
          display: -webkit-flex;
          justify-content: space-between;
          align-items: center;
          .valPerArea_bar {
            width: calc(100% - 3.74vw);
            display: flex;
            display: -webkit-flex;
            justify-items: center;
            height: 0.554vw;
            .bar_per {
              transition: width 0.3s linear;
            }
          }
          .valPerArea_text {
            width: 3.47vw;
            font-size: 0.833vw;
            color: var(--mixtmt_greyColor2);
          }
          &.left {
            left: 0;

            .valPerArea_bar {
              justify-content: flex-end;
              .bar_per {
                border-radius: 0.277vw 0 0 0.277vw;
                background-color: var(--mixtmt_theme_defaultGradient_1_1);
              }
            }
            .valPerArea_text {
              text-align: right;
            }
          }
          &.right {
            right: 0;
            .valPerArea_bar {
              justify-content: flex-start;
              .bar_per {
                border-radius: 0 0.277vw 0.277vw 0;
                background-color: var(--mixtmt_theme_defaultGradient_1_2);
              }
            }
            .valPerArea_text {
              text-align: left;
            }
          }
        }
      }
    }
  }
}
</style>
